import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { loadDeviceImagePlaceholder } from '@models/functions.model';
import {
  DeviceItemDataBP,
  DeviceItemDevice,
  DeviceItemDeviceBP,
  ShoppingSortData
} from '@models/shopping.model';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { DataLoaderCaptureOverrideDirective } from 'tangoe-design-system';

@Component({
  selector: 'ts-bp-device-list',
  templateUrl: './device-list-bp.component.html',
  hostDirectives: [DataLoaderCaptureOverrideDirective],
  imports: [CommonModule, NgbTooltipModule, TranslationPipe, NgbDropdownModule]
})
export class DeviceListBpComponent implements OnChanges {
  @Input() bp_device_list: DeviceItemDataBP[];
  @Input() sort_by: ShoppingSortData;
  @Input() in_cart_device?: DeviceItemDevice | DeviceItemDeviceBP;
  @Output() select_asset_emit: EventEmitter<DeviceItemDataBP> =
    new EventEmitter<DeviceItemDataBP>();
  final_device_list: DeviceItemDeviceBP[] = [];

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.final_device_list = [];

    if (this.bp_device_list && (changes['bp_device_list'] || changes['sort_by'])) {
      this.bp_device_list = this.sortBPDevices(
        this.bp_device_list,
        this.sort_by.field,
        this.sort_by.dir
      );

      this.bp_device_list.forEach((device_data: DeviceItemDataBP) => {
        device_data.devices.forEach((device_item: DeviceItemDeviceBP) => {
          if (this.in_cart_device && this.in_cart_device.id === device_item.id)
            device_item.in_cart = true;

          this.final_device_list.push(device_item);
        });
      });

      this.pinBPCartDevice();
    }
  }

  selectAsset(asset: DeviceItemDeviceBP): void {
    this.bp_device_list.forEach((device_data: DeviceItemDataBP) => {
      device_data.devices.forEach((device_item: DeviceItemDeviceBP) => {
        if (device_item === asset) {
          device_data.devices = [device_item];
          this.select_asset_emit.emit(device_data);
          return;
        }
      });
    });
  }

  getPlaceholder(product_category: string, event: any) {
    return loadDeviceImagePlaceholder(product_category, event);
  }

  getBPDeviceMinimumPrice(device: DeviceItemDeviceBP, price_type: string): string {
    let price: string = '';

    this.bp_device_list.forEach((device_data: DeviceItemDataBP) => {
      device_data.devices.forEach((device_item: DeviceItemDeviceBP) => {
        if (device_item === device)
          switch (price_type) {
            case 'onetime':
              price = device_item.price.onetime.cost_to_currency;
              break;
            case 'monthly':
              price = device_item.price.monthly.cost_to_currency;
              break;
            default:
              break;
          }
      });
    });

    return price;
  }

  hasMonthlyMinimumPrice(device: DeviceItemDeviceBP): boolean {
    let has_monthly_price: boolean = false;

    this.bp_device_list.forEach((device_data: DeviceItemDataBP) => {
      device_data.devices.forEach((device_item: DeviceItemDeviceBP) => {
        if (device_item === device && device_data.monthly_minimum_price) has_monthly_price = true;
      });
    });

    return has_monthly_price;
  }

  // TODO: hasMonthlyMinimumPrice() and bpDeviceInCart() could potentially be combined into one function by using switch case
  bpDeviceInCart(device: DeviceItemDeviceBP): boolean {
    return this.in_cart_device && device.id === this.in_cart_device.id ? true : false;
  }

  private sortBPDevices(
    devices: DeviceItemDataBP[],
    field: string,
    dir: string
  ): DeviceItemDataBP[] {
    switch (field) {
      case 'price':
        return dir === 'asc'
          ? devices.sort((a, b) =>
              a.onetime_minimum_price_fractional < b.onetime_minimum_price_fractional ? -1 : 1
            )
          : devices.sort((a, b) =>
              a.onetime_minimum_price_fractional > b.onetime_minimum_price_fractional ? -1 : 1
            );
      case 'brand':
        return dir === 'asc'
          ? devices.sort((a, b) => (a.devices[0].manufacturer < b.devices[0].manufacturer ? -1 : 1))
          : devices.sort((a, b) =>
              a.devices[0].manufacturer > b.devices[0].manufacturer ? -1 : 1
            );
      case 'carrier':
        return dir === 'asc'
          ? devices.sort((a, b) => (a.devices[0].carrier.name < b.devices[0].carrier.name ? -1 : 1))
          : devices.sort((a, b) =>
              a.devices[0].carrier.name > b.devices[0].carrier.name ? -1 : 1
            );
      default:
        return dir === 'asc'
          ? devices.sort((a, b) =>
              a.onetime_minimum_price_fractional < b.onetime_minimum_price_fractional ? -1 : 1
            )
          : devices.sort((a, b) =>
              a.onetime_minimum_price_fractional > b.onetime_minimum_price_fractional ? -1 : 1
            );
    }
  }

  private pinBPCartDevice(): void {
    if (this.in_cart_device && this.final_device_list.length > 0)
      this.final_device_list.forEach((device_data: DeviceItemDeviceBP, index: number = 0) => {
        if (device_data.in_cart) {
          this.final_device_list?.unshift(this.final_device_list.splice(index, 1)[0]);
          return;
        }

        index++;
      });
  }
}
